import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function FinanciadorEstudiosToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class FinanciadorEstudiosForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<FinanciadorEstudiosToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.financiadorEstudiosEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.financiadorEstudiosEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.financiadorEstudiosPt">
          <TextInput source="namePt" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(FinanciadorEstudiosForm);
